import gql from 'graphql-tag'

export const SIGN_UP = gql`
  mutation SignUp($input: SignUpInputGraphql!) {
    signUp(input: $input) {
      id
    }
  }
`

export const GET_OVERLAYED_CLIENT_TOKEN = gql`
  mutation LogAs($input: LogAsInput!) {
    logAs(input: $input) {
      userJWT
    }
  }
`
export const GET_CURRENT_USER_CRUCIAL_FIELDS = gql`
  query CurrentUserCrucialFields(
    $input: ClientCustomDashboardInputGraphql
  ) {
    me {
      organization {
        id
      }
      client {
        __typename
        id
        name
        isConnectedToTrackdechets
        phoneNumber
        autosignEnabledForTrackdechets
        customDashboard(input: $input)
        hasCollects
      }
      user {
        email
        firstName
        id
        lastName
        role
        acceptedTermsAt
        entitlements {
          companies {
            id
            role
          }
          organisations {
            id
            role
          }
          sites {
            id
            role
          }
        }
        driver {
          id
        }
        assignedRoles {
          collection {
            role {
              id
              name
              ... on CompanyRole {
                company {
                  id
                  name
                }
              }
              ... on OrganizationRole {
                organization {
                  id
                  name
                }
              }
              ... on SiteRole {
                site {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`
